<template>
  <div class="account">
    <Header />
    <Orders />
    <Footer />
  </div>
</template>

<script>
import Header from "../../src/components/template/Header";
import Footer from "../../src/components/template/Footer";
import Orders from "../../src/components/account/Orders/Orders";
export default {
  metaInfo() {
    return {
      title: "Meus Pedidos | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "Acompanhe todos seus pedidos realizados no Leveros Integra de forma simples e rápida.",
        },
        { property: "og:title", content: "Meus Pedidos | Leveros Integra" },
        { property: "og:site_name", content: "Leveros Integra" },
        {
          property: "og:description",
          content:
            "Acompanhe todos seus pedidos realizados no Leveros Integra de forma simples e rápida.",
        },
        { name: "robots", content: "noindex,nofollow" },
      ],
    };
  },
  components: {
    Header,
    Footer,
    Orders,
  },
};
</script>